/**
 * Step indicator with progress dots
 */
const StepIndicator = ({ totalSteps, currentStep }) => {
  return (
    <div className="flex gap-2 justify-center mb-8">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <div
          key={index}
          className={`
            h-2 rounded-full transition-all duration-300
            ${index + 1 === currentStep
              ? 'w-8 bg-blue-500' // Active step
              : index + 1 < currentStep
              ? 'w-2 bg-green-500' // Completed step
              : 'w-2 bg-gray-300 dark:bg-gray-600' // Inactive step
            }
          `}
        />
      ))}
    </div>
  )
}

export default StepIndicator
